import { render, staticRenderFns } from "./SetSecgroup.vue?vue&type=template&id=0e3f3785"
import script from "./SetSecgroup.vue?vue&type=script&lang=js"
export * from "./SetSecgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports